import React from 'react';
import { Navigate } from 'react-router-dom';
import RL from './route-literals';
import { TcpTypes } from '../slices/terms-conditions-policies';

const AppOutlet = React.lazy(() => import('../slices/app-outlet'));
const SignIn = React.lazy(() => import('../slices/sign-in'));
const ConsentPage = React.lazy(() => import('../slices/consent-page'));
const ResetPassword = React.lazy(() => import('../slices/reset-password'));
const UnlockUser = React.lazy(() => import('../components/views/unlock-user'));
const TermsConditionsPolicies = React.lazy(() => import('../slices/terms-conditions-policies'));

const AppRoutes = [
  {
    element: <AppOutlet />,
    path: RL.root,
    children: [
      {
        index: true,
        element: <SignIn />,
      },
      {
        path: '/*',
        element: <Navigate to="/" />,
      },
      {
        path: RL.consent,
        element: <ConsentPage />,
      },
      {
        path: RL.resetPassword,
        element: <ResetPassword />,
      },
      {
        path: RL.unlockUser,
        element: <UnlockUser />,
      },
      {
        path: RL.termsConditions,
        element: <TermsConditionsPolicies type={TcpTypes.TERMS_CONDITIONS} />,
      },
      {
        path: RL.privacyPolicy,
        element: <TermsConditionsPolicies type={TcpTypes.PRIVACY_POLICY} />,
      },
    ],
  },
];

export default AppRoutes;
